import React from 'react';
import { useCountdown } from '../hooks/useCountdown';

const DateTimeDisplay = ({ value, type, isDanger }) => {
  return (
    <div>
      <p className='text-[32px] md:text-[52px] lg:text-[96px] font-bold text-white leading-[58px] lg:leading-[105px] mb-2 w-[75px] md:w-[125px] lg:w-[175px]'>
        {value}
      </p>
      <span className='md:text-[24px] lg:text-[32px]'>{type}</span>
    </div>
  );
};

function Countdown({ date, simple = false }) {
  const [days, hours, minutes, seconds] = useCountdown(date);

  if (simple) {
    if (days > 0) {
      return (
        <>
          {days} days {hours} hrs {minutes} mins {seconds} s
        </>
      );
    } else if (hours > 0) {
      return (
        <>
          {hours} hrs {minutes} mins {seconds} s
        </>
      );
    } else if (minutes > 0) {
      return (
        <>
          {minutes} mins {seconds} s
        </>
      );
    } else if (seconds > 0) {
      return <>{seconds} s</>;
    }

    return '';
  }

  return (
    <div className='flex flex-col items-center justify-center text-center mt-[100px]'>
      <div className='flex space-x-5 lg:space-x-20'>
        <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
        <DateTimeDisplay value={hours} type={'Hours'} />
        <DateTimeDisplay value={minutes} type={'Mins'} />
        <DateTimeDisplay value={seconds} type={'Seconds'} />
      </div>
    </div>
  );
}
export default Countdown;
